import Vue from 'vue';
import FubonComponent from 'ns-common-web-re';

Vue.use(FubonComponent);
